import * as ActionTypes from '../Login';
export function openAuthModal(data) {
    return {
        type: ActionTypes.OPEN_AUTH_MODAL,
        data: data
    };
}
export function closeAuthModal() {
    return {
        type: ActionTypes.CLOSE_AUTH_MODAL
    };
}



// WEBPACK FOOTER //
// ./src/actions/auth/creators/Login.js